var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"small-button",on:{"click":_vm.emitPress}},[_c('icon',{attrs:{"icon":['fal', _vm.icon],"size":"me"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }